import { gql } from '@apollo/client';

const UPDATE_WISHLIST = gql`
    mutation updateWishlist(
        $name: String!,
        $wishlistId: ID!,
        $accountId: Int!,
        $groupId: String,
    ) {
        updateWishlist(
            name: $name
            wishlistId: $wishlistId
            accountId: $accountId
            groupId: $groupId
        ) {
            name
            uid
            visibility
        }
    }
`;
export default UPDATE_WISHLIST;